import { PATH_DASHBOARD, PATH_HOME } from 'src/constants/spa-routes';
import React from 'react';
import { ProductsType } from 'src/constants/products';
import { ACCOUNT_ACCESS_ROLES, SUBSCRIPTION_ACCESS_ROLES } from 'src/constants/roles';
import { NOTION_PAGES } from 'src/shared/constants';
import { SidebarHomeIcon } from 'src/assets/icons/sidebar/sidebarHomeIcon';
import { SidebarUserIcon } from 'src/assets/icons/sidebar/sidebarUserIcon';
import { SidebarCardIcon } from 'src/assets/icons/sidebar/sidebarCardIcon';
import { SidebarHelpIcon } from 'src/assets/icons/sidebar/sidebarHelpIcon';
import { SidebarRobotIcon } from 'src/assets/icons/sidebar/sidebarRobotIcon';
import { SidebarSupportIcon } from 'src/assets/icons/sidebar/sidebarSupportIcon';
import { BiCoSupportIcon } from 'src/assets/icons/biCoSupportIcon';

export const firstMenuItemsGeneral = [
  {
    id: 0,
    title: 'Home',
    external: false,
    icon: <SidebarHomeIcon />,
    navigateTo: PATH_HOME.ROOT,
    disabled: false,
  },
];
export const menuItemsGeneral = [
  {
    id: 0,
    title: 'Account & Workspace',
    external: false,
    icon: <SidebarUserIcon />,
    navigateTo: PATH_DASHBOARD.ACCOUNT,
    access: ACCOUNT_ACCESS_ROLES,
  },
  {
    id: 1,
    title: 'Subscription',
    external: false,
    icon: <SidebarCardIcon />,
    navigateTo: PATH_DASHBOARD.SUBSCRIPTION,
    access: SUBSCRIPTION_ACCESS_ROLES,
  },
  {
    id: 2,
    title: 'Help',
    icon: <SidebarHelpIcon />,
    external: true,
    navigateTo: NOTION_PAGES.HELP_PAGE,
    disabled: false,
  },
];
export const menuItemsProducts = [
  {
    id: 0,
    title: 'AI Agents',
    external: false,
    type: ProductsType.customer,
    color: 'text-[#8576F3]',
    accentHex: '#8576F3',
    addLabel: 'AI Agent',
    icon: <SidebarRobotIcon />,
  },
  {
    id: 1,
    title: 'AI Assistants',
    external: false,
    type: ProductsType.agent,
    color: 'text-[#54DAE2]',
    accentHex: '#54DAE2',
    addLabel: 'AI Assistant',
    icon: <SidebarSupportIcon />,
  },
  {
    id: 2,
    title: 'AI BI',
    external: false,
    type: ProductsType.bi,
    color: 'text-chartreuse_yellow',
    accentHex: '#DFF800',
    addLabel: 'AI BI',
    icon: <BiCoSupportIcon width="18" height="18" />,
  },
];
